import { Accessor, createMemo, createRoot } from 'solid-js'
import getSessionUserId from './getSessionUserId'

const isGuestMemo: Accessor<boolean> = createRoot(() => {
  const isGuestMemo = createMemo((): boolean => {
    return !getSessionUserId()
  })

  return isGuestMemo
})

export default isGuestMemo
